import SocketCentrifugeBase from '@/api/sockets/SocketCentrifugeBase';
import { Callback, Dict } from '@/types/utility';

export enum MeasurementSocketEvents {
  STUB = '',
}

enum MeasurementSocketRPC {
  ESTIMATION_UPDATE = 'measurement.estimationUpdate',
}

export default class MeasurementSocket extends SocketCentrifugeBase<
  MeasurementSocketEvents,
  MeasurementSocketRPC
> {
  private static connections: Dict<MeasurementSocket> = {};

  protected listeners = {
    // TODO Try to remove after the future TS updates. Now TS version is 4.6.3
    // [] as Callback[] is a hack to fix a TS bug. Otherwise, the type of the abstract member will be set to never[]
    [MeasurementSocketEvents.STUB]: [] as Callback<[data: object]>[],
  };

  private constructor(
    public id: number,
    onConnect?: Callback<[SocketCentrifugeBase<MeasurementSocketEvents, MeasurementSocketRPC>]>,
  ) {
    super(`personal:measurement-${id}`, {
      handleEvents: () => null,
      onConnect,
    });

    this.dataAddedToEveryRequest = { measurement_id: this.id };
  }

  public static start(
    id: number,
    onConnect?: Callback<[SocketCentrifugeBase<MeasurementSocketEvents, MeasurementSocketRPC>]>,
  ) {
    const connection = MeasurementSocket.connections[id];
    if (connection) {
      connection.addSession();
      onConnect?.(connection);
      return connection;
    }

    MeasurementSocket.connections[id] = new MeasurementSocket(id, onConnect);
    return MeasurementSocket.connections[id];
  }

  public close(listenersGroupId?: string): boolean {
    const isClosed = super.close(listenersGroupId);

    if (isClosed) {
      delete MeasurementSocket.connections[this.id];
    }

    return isClosed;
  }

  public saveEstimation(estimation) {
    return this.sendNamedRPC(MeasurementSocketRPC.ESTIMATION_UPDATE, {
      estimation,
    });
  }
}
